// React dependent imports
import * as React from 'react';
import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

// Material UI Components
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import API from '../../api/axiosConfig';


export default function ProjectCreationForm() {

  // Constant variables for setting title and description
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // New state

  // Initialize navigator
  const navigate = useNavigate();


  // Event handler for clicking the login button.
  const handleClick = async (e) => {
    e.preventDefault(); // Prevents default form submission behavior

    if (!title || !desc) {
        alert("ERROR: Title and description cannot be empty.");
        return;
    }

    setIsSubmitting(true); // Disable the button immediately

    try {
        // Make the POST request to the backend
        await API.post('/api/projects/create', {
            title: title,
            description: desc
        });

        // Check the response
        console.log("New project created.");
        alert("Project created successfully!");

        // Clear the form fields
        setTitle('');
        setDesc('');
        // Navigate to the projects page
        navigate("/projects");

    } catch (error) {
      if (error.response?.status !== 401) {
        console.error("Error:", error.response?.data);
        alert(`ERROR: ${error.response?.data?.message || "Unable to create project."}`);
      }
    } finally {
      setIsSubmitting(false);
    }
};


  // Returns the RegisterForm Component.
  return (
    <Paper elevation={6} sx={{ variant: "outlined", padding: '16px', margin: '16px auto', width: 600 }}>
      <Box
        component="form"
        noValidate
        autoComplete="off"
      >

        <Box sx={{ textAlign: 'left', margin: '20px', marginLeft: '75px' }}>
            <TextField 
                id="outlined-basic" 
                label="Title" 
                variant="outlined"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
                sx={{ width: '200px' }} // Optional: control the width
            />
        </Box>
            <TextField
            id="outlined-multiline-static"
            label="Description"
            multiline
            rows={5}
            value={desc}
            onChange={(e)=>setDesc(e.target.value)}
            required
            sx={{width:'450px'}}
            />

        <Box sx={{ textAlign: 'right', margin: '20px', marginRight: '75px' }}>
            <Button
              disabled={isSubmitting}
              variant="contained"
              type="submit"
              onClick={handleClick}
              sx={{ 
                backgroundColor: 'darkred',
                minWidth: '200px',
                minHeight: '50px', 
                '&:hover': { backgroundColor: 'red' }}}
            >
            <b>{isSubmitting ? "Creating..." : "Create"}</b>
            </Button>
        </Box>
      </Box>
    </Paper>
  );
}
